export class ListObjectStoreExclusionRulesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rules",
            "baseName": "rules",
            "type": "Array<ObjectStoreExclusionRule>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListObjectStoreExclusionRulesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
